import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { racingLicenseGradeService } from "../../_services/racingLicenseGrade.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
    isMinor: boolean,
    parentId: number
}

export const RacingLicenseGradeAutoComplete = (params: IStandardExtAutocomplete) => {

    function fetchItems() {
        return racingLicenseGradeService
            .dropdown(params.parentId, params.isMinor);
    }

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={fetchItems}
            label={"Racing Licence Grade Select"} />
    );
}